import { useTranslation } from 'react-i18next';

import { StyledText } from '@selfserve/react-ui';

import {
  StyledLoader,
  StyledPriceContainer,
  StyledPricePair,
} from '../feature/summary';

interface Props {
  withLine: boolean;
  isLoading: boolean;
  price: string;
  name: string;
  quantity: number;
}

export const SummaryPlan = ({
  withLine,
  isLoading,
  price,
  name,
  quantity,
}: Props) => {
  const { t } = useTranslation();
  return (
    <StyledPriceContainer withLine={withLine}>
      <StyledPricePair>
        <StyledText as="div" className="summary-item-name" bold isSmall>
          {name}
        </StyledText>
        <StyledText as="div" bold isSmall>
          {isLoading ? <StyledLoader /> : `$${price}`}
        </StyledText>
      </StyledPricePair>
      <StyledPricePair secondary>
        <StyledText as="div" className="summary-item-description">
          <span>
            {quantity} {t(`common.${quantity > 1 ? 'rooms' : 'room'}`)}
          </span>
        </StyledText>
      </StyledPricePair>
    </StyledPriceContainer>
  );
};
